import React from "react";
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

function StorageTabItems(props) {
	return (
		<div className="tab-pane" id="storage">
			<Row>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Elastic Volume Service</p>
						<p className="box-body">
							High-Performance Solid-State Drive (SSD) block
							storage designed for intensive workloads.
						</p>
						<Link className="learn-more" to="/elasticvolumeservice" target="_blank">
							Learn more <span className="learn-arrow"> </span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Premium Backup Service </p>
						<p className="box-body">
							Take backup of your storage securely and protect
							your data from loss.
						</p>
						<Link className="learn-more" to="/premiumbackupservice" target="_blank">
							Learn more <span className="learn-arrow"> </span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Object Storage Service:</p>
						<p className="box-body">
							Object Storage Service (OSS) is a stable, secure,
							efficient, and easy-to-use cloud storage service.
						</p>
						<Link className="learn-more" to="/objectstorageservice" target="_blank">
							Learn more <span className="learn-arrow"> </span>
						</Link>
					</div>
				</Col>
                </Row>
		</div>
	);
}

export default StorageTabItems;
